// 引入api
import { fun_PostAction, fun_Download } from "@/api";
//引入下载方法
import { fun_DownloadFile } from "@/utils/validate.js";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      /*************************公告信息***************************/
      guid: null, // 主键
      purchase: true, // 收起 展开 采购概况
      announcement: true, // 收起 展开 公告基本信息
      items: true, // 收起 展开 采购品目
      BitemInformation: true, // 收起 展开 项目信息 B
      detailInformation: true, // 收起 展开 明细信息
      packageInformation: true, // 收起 展开 包件信息
      AitemInformation: true, // 收起 展开 项目信息 A
      correct: true, // 收起 展开 更正公告
      packageBalse: true, // 收起 展开 包件
      purchasers: true, // 收起 展开 采购人与采购代理（项目联系方式）
      detailedAnnouncement: true, // 收起 展开 详细公告内容
      file: true, // 收起 展开 附件信息
      DitemInformation: true, // 收起 展开 项目信息 D
      // 项目信息
      detail: {
        /********************* 项目信息 *********************/
        guid: null, // 主键
        method: null, // 处理方式
        title: null, // 标题
        jjxmmc: null, // 竞价项目名称
        jjxmbh: null, // 竞价项目编号
        cgrmc: null, // 采购人名称
        cgrdz: null, // 采购人地址
        cgjbr: null, // 采购经办人
        cgjbrdh: null, // 采购经办人电话
        cgfs: null, // 采购方式
        zgscfs: null, // 资格审查方式
        ggkssj: null, // 公告开始时间
        ggjzsj: null, // 公告截止时间
        jjkssj: null, // 竞价开始时间
        cgxmmc: null, // 项目名称
        cgxmbh: null, // 项目编号
        cgdw: null, // 采购单位
        cgdwdz: null, // 采购单位地址
        cglxr: null, // 采购联系人
        cglxrdh: null, // 采购联系人电话
        cglxrdz: null, // 采购联系人地址
        yjxdsj: null, // 预计下单时间
        zjcgfj: null, // 直购采购附件
        srggrq: null, // 首次公告日期
        cglb: null, // 采购类别
        gzsx: null, // 更正事项
        gznr: null, // 更正内容
        gzrq: null, // 更正日期
        kbdd: null, // 开标及投标文件送达地点
        ggxz: null, // 公告性质
        ggfbsj: null, // 公告发布时间
        cgzgyswjhqfs: null, // 采购/资格预审文件获取方式
        bz: null, // 备注
        jzcgjg: null, // 集中采购机构
        jzcgjglxr: null, // 集中采购机构联系人
        jzcgjglxdh: null, // 集中采购机构联系电话
        jzcgjglxdz: null, // 集中采购机构联系地址
        content: null, // 内容
      },
      /********************* 包件一览 *********************/
      // 列表loading状态
      bjTableColumns: [
        {
          label: "包件编号",
          prop: "bjbh"
        },
        {
          label: "包件名称",
          prop: "bjmc"
        },
      ],
      bjTableData: [],
      /********************* 包件信息一览 *********************/
      bjxxTableData: [],
      /********************* 包件明细一览 *********************/
      // 列表loading状态
      bjmxTableColumns: [
        {
          label: "采购类目",
          prop: "cglm"
        },
        {
          label: "参数要求",
          prop: "csyq"
        },
        {
          label: "数量",
          prop: "sl"
        },
        {
          label: "单位",
          prop: "dw"
        },
        {
          label: "采购预算（元）",
          prop: "cgys"
        },
        {
          label: "备注说明",
          prop: "bzsm"
        },
      ],
      bjmxTableData: [],
      /********************* 采购品目一览 *********************/
      // 列表loading状态
      cgpmTableColumns: [
        {
          label: "采购品类",
          prop: "cgpz"
        },
        {
          label: "采购数量",
          prop: "cgsl"
        },
        {
          label: "采购预算",
          prop: "cgys"
        },
      ],
      cgpmTableData: [],
      /************************ 附件信息 **************************/
      // 列表loading状态
      fileTableColumns: [
        {
          label: "文件名",
          prop: "ymWjm"
        },
        {
          label: "创建时间",
          prop: "ymCjsj"
        },
      ],
      fileTableData: [],
    };
  },

  mounted() {
    // 获取主键
    this.guid = this.$route.query.guid;
    // 获取公告详情
    this.fun_GetDetail();
    // 获取包件一览数据
    this.fun_GetPurchaseAnnouncementBjList();
    // 获取包件信息一览数据
    this.fun_GetPurchaseAnnouncementBjxxList();
    // 获取包件明细一览数据
    this.fun_GetPurchaseAnnouncementBjmxList();
    // 获取采购品目一览数据
    this.fun_GetPurchaseAnnouncementCgpmList();
    // 货物文件下载一览数据
    this.fun_GetFileDownloadConnectionList();
  },
  // 自定义事件
  methods: {
    /***********************************公告信息**************************************/
    /**
     * 获取公告信息
     */
    fun_GetDetail() {
      // 请求
      fun_PostAction("/hiProcurement/purchaseAnnouncementDetail", {
        guid: this.guid, // 主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          this.detail = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取包件一览数据
     * @author 滕威
     */
    fun_GetPurchaseAnnouncementBjList() {
      // 执行获取列表接口
      fun_PostAction("/hiProcurement/purchaseAnnouncementBjList", {
        pidGuid: this.guid, // 父亲主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.bjTableData = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取包件信息一览数据
     * @author 滕威
     */
    fun_GetPurchaseAnnouncementBjxxList() {
      // 执行获取列表接口
      fun_PostAction("/hiProcurement/purchaseAnnouncementBjxxList", {
        pidGuid: this.guid, // 父亲主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.bjxxTableData = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取包件明细一览数据
     * @author 滕威
     */
    fun_GetPurchaseAnnouncementBjmxList() {
      // 执行获取列表接口
      fun_PostAction("/hiProcurement/purchaseAnnouncementBjmxList", {
        djglidGuid: this.guid, // 父亲主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.bjmxTableData = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取采购品目一览数据
     * @author 滕威
     */
    fun_GetPurchaseAnnouncementCgpmList() {
      // 执行获取列表接口
      fun_PostAction("/hiProcurement/purchaseAnnouncementCgpmList", {
        pidGuid: this.guid, // 父亲主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.cgpmTableData = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取文件下载一览数据
     * @author 滕威
     */
    fun_GetFileDownloadConnectionList() {
      // 执行获取列表接口
      fun_PostAction("/hiProcurement/fileDownloadConnectionList", {
        pidGuid: this.guid, // 父亲主键
        djglidGuid: this.guid, // 父亲主键
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 解析后台返回的结果集，判断是否成功
        if (result) {
          // 成功的场景
          // 将请求到的table数据渲染到table
          this.fileTableData = data;
        } else {
          // 请求失败的场景
          // 请求失败，弹出失败msg的消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下载
     * @author 滕威
     */
    fun_DownloadFiles(filePath) {
      if (filePath) {
        const form = {
          filePath: filePath
        };
        // 下载文件
        fun_Download("/downloadLocal", form).then(res => {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;
          if (fileNames) {
            let regFileNames = fileNames.match(/=(.*)$/)[1];
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
          } else {
            fun_DownloadFile(res, Math.random() + ".pdf");
          }
        });
      } else {
        this.$message.error("文件不存在！");
      }
    },
  }
};
